import React from 'react';
import { Backdrop, Modal } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { CircularProgressWithLabel } from './CircularProgressWithLabel';

type AppBackdropProps = {
  open: boolean;
  progress: number;
};

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
    background: 'unset'
  }
}));

export const AppBackdrop: React.FC<AppBackdropProps> = ({
  open,
  progress
}: AppBackdropProps) => {
  const classes = useStyles();

  return (
    <Modal open={open}>
      <Backdrop
        data-testid="back-drop"
        className={classes.backdrop}
        open={open}
      >
        <CircularProgressWithLabel progress={progress} />
      </Backdrop>
    </Modal>
  );
};
